<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin() == true || $gate.isHRAdmin() == true">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Manage Users</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <div class="col-md-12">
                    <div class="card card-danger card-outline collapsed-card">
                        <div class="card-header">
                            <div class="card-title">Data Filters</div>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool btn-danger"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i> Show/Hide
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Results Per Page:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            min="5"
                                            value="10"
                                            v-model="search_params.results"
                                            placeholder=" Enter No. of results"
                                            @input="getUsers('/api/getUsers')"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.emp_id ? 'has-error' : '',
                                        ]"
                                    >
                                        <span
                                            class="right badge badge-secondary"
                                            >Employee ID:</span
                                        >

                                        <v-select
                                            v-model="search_params.emp_id"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="employees"
                                            :reduce="
                                                (employees) =>
                                                    employees.emp_code
                                            "
                                            name="employee"
                                            placeholder="Select Employee Code"
                                            :value="
                                                (employees) =>
                                                    employees.emp_code
                                            "
                                        ></v-select>

                                        <span
                                            v-if="errors.emp_id"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid ID.</span
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="search_params.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Name:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="search_params.name"
                                            placeholder=" Enter the name"
                                            @keyup.enter="
                                                getUsers('/api/getUsers')
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >User ID:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="search_params.id"
                                            placeholder=" Enter the user ID"
                                            @keyup.enter="
                                                getUsers('/api/getUsers')
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Division:</span
                                        >
                                        <v-select
                                            v-model="search_params.division"
                                            class="form-control"
                                            type="text"
                                            label="division_name"
                                            :options="divisions"
                                            :reduce="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                            name="division"
                                            placeholder="Select Division Category"
                                            :value="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Item Category:</span
                                        >
                                        <v-select
                                            v-model="search_params.category"
                                            class="form-control"
                                            type="text"
                                            label="category_name"
                                            :options="categories"
                                            :reduce="
                                                (categories) =>
                                                    categories.category_name
                                            "
                                            name="category"
                                            placeholder="Select Item Category"
                                            :value="
                                                (categories) =>
                                                    categories.category_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <v-select
                                            v-model="search_params.product"
                                            class="form-control"
                                            type="text"
                                            label="product_name"
                                            :options="products"
                                            :reduce="
                                                (products) =>
                                                    products.product_name
                                            "
                                            name="product"
                                            placeholder="Select Product Category"
                                            :value="
                                                (products) =>
                                                    products.product_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Brands:</span
                                        >
                                        <v-select
                                            v-model="search_params.brand"
                                            class="form-control"
                                            type="text"
                                            label="brand_name"
                                            :options="brands"
                                            :reduce="
                                                (brands) => brands.brand_name
                                            "
                                            name="brand"
                                            placeholder="Select Brand"
                                            :value="
                                                (brands) => brands.brand_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Phone:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="search_params.phone"
                                            placeholder=" Enter the phone no."
                                            @keyup.enter="
                                                getUsers('/api/getUsers')
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Is Team Leader?:</span
                                        >
                                        <select
                                            v-model="
                                                search_params.is_team_leader
                                            "
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >User Type:</span
                                        >
                                        <select
                                            v-model="search_params.user_type"
                                            class="form-control"
                                        >
                                            <option value="#">
                                                ---Select Usertype---
                                            </option>
                                            <option value="sys-admin">
                                                System Administrator
                                            </option>
                                            <option value="sales-admin">
                                                Sales Admin
                                            </option>
                                            <option value="zonal-manager">
                                                Zonal Manager
                                            </option>
                                            <option value="warehouse-manager">
                                                Warehouse Manager
                                            </option>
                                            <option value="branch-manager">
                                                Branch Manager
                                            </option>
                                            <option value="branch-accountant">
                                                Branch Accountant
                                            </option>
                                            <option value="store-manager">
                                                Store Manager
                                            </option>
                                            <option value="b2b-sales-executive">
                                                B2B Sales Executive
                                            </option>
                                            <option value="b2c-sales-executive">
                                                B2C Sales Executive
                                            </option>
                                            <option value="brand-promoter">
                                                Brand Promoter
                                            </option>
                                            <option value="service-tech">
                                                Service Executive
                                            </option>
                                            <option value="service-manager">
                                                Service Manager
                                            </option>
                                            <option value="service-agent">
                                                Service Assistant
                                            </option>
                                            <option value="service-admin">
                                                Service Administrator
                                            </option>
                                            <option value="purchase-admin">
                                                Purchase Administrator
                                            </option>
                                            <option value="purchase-manager">
                                                Purchase Manager
                                            </option>
                                            <option value="auditor-vendors">
                                                Auditor (Vendors)
                                            </option>
                                            <option value="mis-admin">
                                                MIS Admin
                                            </option>
                                            <option value="secondary-mis-admin">
                                                Secondary MIS Admin
                                            </option>
                                            <option value="installation-admin">
                                                Installation Administrator
                                            </option>
                                            <option
                                                value="installation-manager"
                                            >
                                                Installation Manager
                                            </option>
                                            <option value="ext-warr-admin">
                                                Extended Warranty Admin
                                            </option>
                                            <option value="replacement-manager">
                                                Replacement Manager
                                            </option>
                                            <option value="doa-manager">
                                                DOA Manager
                                            </option>
                                            <option value="expense-admin">
                                                Expense Admin
                                            </option>
                                            <option value="auditor">
                                                Auditor
                                            </option>
                                            <option
                                                value="online-sales-manager"
                                            >
                                                Online Sales Manager
                                            </option>
                                            <option
                                                value="online-sales-associate"
                                            >
                                                Online Sales Associate
                                            </option>
                                            <option value="marketing-admin">
                                                Marketing Admin
                                            </option>
                                            <option value="marketing-manager">
                                                Marketing Manager
                                            </option>
                                            <option value="hr-admin">
                                                HR Admin
                                            </option>
                                            <option value="cc-manager">
                                                Help Desk Manager
                                            </option>
                                            <option value="cc-agent">
                                                Help Desk Executive
                                            </option>
                                            <option value="delivery-driver">
                                                Delivery Driver
                                            </option>
                                            <option value="front-desk">
                                                Front Desk
                                            </option>
                                            <option value="user">
                                                Customer
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!--<div class="col-sm-3">
                            <div class="form-group float-left">
                                <button class="btn btn-secondary" @click="excel"><i class="fa fa-print"></i> Generate Excel</button>
                            </div>-->
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div
                                        class="form-group float-left"
                                        style="width: 100% !important"
                                    >
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="getUsers('/api/getUsers')"
                                        >
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div
                                        class="form-group float-left"
                                        style="width: 100% !important"
                                    >
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            <i class="fa fa-times"></i> Reset
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div
                                        class="form-group float-left"
                                        style="width: 100% !important"
                                    >
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="
                                                exportUsers('/api/usersExport')
                                            "
                                        >
                                            <i class="fa fa-print"></i> Export
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- main row for all icons  -->
                <div class="col-md-12">
                    <div class="card card-danger card-outline">
                        <div class="card-header">
                            <span class="float-left"
                                ><pagination
                                    :pagination="pagination"
                                    @prev="getUsers(pagination.prevPageUrl)"
                                    @next="getUsers(pagination.nextPageUrl)"
                                ></pagination
                            ></span>
                            <button
                                class="btn btn-danger float-right"
                                @click="addModal"
                            >
                                <i class="fa fa-plus"></i> Add User
                            </button>
                        </div>
                        <div class="card-body overflow-auto">
                            <!-- <img v-if="lots==''" src="../images/nodata.svg">	 -->
                            <img v-if="users == ''" src="" />

                            <!-- content here -->
                            <datatable
                                style="margin-top: 1%"
                                :columns="columns"
                                v-else
                            >
                                <tbody>
                                    <tr
                                        :class="[
                                            man.emp_id ? '' : 'table-secondary',
                                        ]"
                                        v-for="(man, index) in users"
                                        :key="man.id"
                                    >
                                        <td>
                                            <p>
                                                <span
                                                    class="right badge badge-primary"
                                                    >ID:
                                                    {{ man.id }}&nbsp;</span
                                                >&nbsp;
                                                {{ man.first_name }}
                                                {{ man.last_name }}
                                            </p>
                                            <p v-if="man.designation != null">
                                                {{ man.designation }}
                                            </p>
                                        </td>
                                        <td>{{ man.phone }}</td>
                                        <td>
                                            <h5>
                                                <span
                                                    v-if="man.emp_id != null"
                                                    class="right badge badge-secondary"
                                                    >{{ man.emp_id }}</span
                                                >
                                            </h5>
                                        </td>
                                        <td>{{ man.branch }}</td>
                                        <td>
                                            {{ man.user_type }}
                                            <span
                                                v-if="man.is_team_leader == '1'"
                                                >(TL)</span
                                            >
                                        </td>
                                        <td
                                            v-if="man.status == 'Active'"
                                            class="badge-success"
                                        >
                                            <div
                                                class="custom-control custom-switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'usera' + index"
                                                    checked
                                                    @input="
                                                        changeUserStatus(man.id)
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'usera' + index"
                                                    >Active</label
                                                >
                                            </div>
                                        </td>
                                        <td v-else class="badge-danger">
                                            <div
                                                class="custom-control custom-switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'useri' + index"
                                                    @input="
                                                        changeUserStatus(man.id)
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="'useri' + index"
                                                    >Inactive</label
                                                >
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-secondary"
                                                @click="viewProfile(man)"
                                            >
                                                <i class="fa fa-file"></i>
                                                Profile
                                            </button>
                                            <button
                                                class="btn btn-warning"
                                                @click="view(man)"
                                            >
                                                <i class="fa fa-eye"></i> Auth
                                                Info
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                @click="edit(man)"
                                            >
                                                <i class="fa fa-edit"></i> Edit
                                            </button>
                                            <button
                                                class="btn btn-danger"
                                                @click="passwd(man)"
                                            >
                                                <i class="fa fa-cog"></i>
                                                Password
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </datatable>
                            <!-- content here -->
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getUsers(pagination.prevPageUrl)"
                                @next="getUsers(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <div class="modal" tabindex="-1" role="dialog" id="addModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add User</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="addUser">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.emp_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Employee ID:</span
                                                >

                                                <v-select
                                                    v-model="form.emp_id"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="employees"
                                                    :reduce="
                                                        (employees) =>
                                                            employees.emp_code
                                                    "
                                                    name="employee"
                                                    placeholder="Select Employee Code"
                                                    :value="
                                                        (employees) =>
                                                            employees.emp_code
                                                    "
                                                ></v-select>

                                                <span
                                                    v-if="errors.emp_id"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    ID.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.branch
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Branch:</span
                                                >
                                                <v-select
                                                    v-model="form.branch"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="branches"
                                                    :reduce="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                    name="branch"
                                                    placeholder="Select Branch"
                                                    :value="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                ></v-select>
                                                <span
                                                    v-if="errors.branch"
                                                    :class="['badge bg-danger']"
                                                    >Please choose a valid
                                                    branch.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.apx_user_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Salesperson Code:</span
                                                >
                                                <v-select
                                                    v-model="form.apx_user_id"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="employees"
                                                    :reduce="
                                                        (employees) =>
                                                            employees.sp_code
                                                    "
                                                    name="employee"
                                                    placeholder="Select Salesperson Code"
                                                    :value="
                                                        (employees) =>
                                                            employees.sp_code
                                                    "
                                                ></v-select>

                                                <!--							<v-select v-model="form.apx_user_id" type="text" label="namecode" :options="employees" :reduce="employees => employees.sp_code" name="apx_user_id" placeholder="Select SAP user" :value="employees => employees.sp_code"></v-select>-->
                                                <!--							<span v-if="errors.apx_user_id" :class="['badge bg-danger']">Please choose a valid user.</span>-->
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.apx_user_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >SPLR CODE:</span
                                                >
                                                <select
                                                    v-model="form.slpr_code"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                >
                                                    <option
                                                        v-for="e in sp_details"
                                                        :key="e.id"
                                                        :value="e.SLPR_CODE"
                                                    >
                                                        {{ e.SLPR_CODE }} -
                                                        {{ e.SLPR_NAME }} -
                                                        {{ e.SLPR_PHONE }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.first_name
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >First Name:</span
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the first name of the employee"
                                                    v-model="form.first_name"
                                                />
                                                <span
                                                    v-if="errors.first_name"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    name.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.last_name
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Last Name:</span
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the last name of the employee"
                                                    v-model="form.last_name"
                                                />
                                                <span
                                                    v-if="errors.last_name"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    name.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.phone
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Phone:</span
                                                >
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Enter the phone number of the employee"
                                                    v-model="form.phone"
                                                    min="1000000000"
                                                />
                                                <span
                                                    v-if="errors.phone"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    number.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.email
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Email:</span
                                                >
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Enter the email of the employee"
                                                    v-model="form.email"
                                                />
                                                <span
                                                    v-if="errors.email"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    email.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.password
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Password:</span
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    placeholder="Enter the password of the employee"
                                                    v-model="form.password"
                                                />
                                                <span
                                                    v-if="errors.password"
                                                    :class="['badge bg-danger']"
                                                    >Please enter valid matching
                                                    passwords.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.password_confirmation
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Confirm Password:</span
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    placeholder="Enter the password of the employee"
                                                    v-model="
                                                        form.password_confirmation
                                                    "
                                                />
                                                <span
                                                    v-if="
                                                        errors.password_confirmation
                                                    "
                                                    :class="['badge bg-danger']"
                                                    >Please enter valid matching
                                                    passwords.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.user_type
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >User Type:</span
                                                >
                                                <select
                                                    v-model="form.user_type"
                                                    class="form-control"
                                                >
                                                    <option value="sys-admin">
                                                        System Administrator
                                                    </option>
                                                    <option value="sales-admin">
                                                        Sales Admin
                                                    </option>
                                                    <option
                                                        value="zonal-manager"
                                                    >
                                                        Zonal Manager
                                                    </option>
                                                    <option
                                                        value="warehouse-manager"
                                                    >
                                                        Warehouse Manager
                                                    </option>
                                                    <option
                                                        value="branch-manager"
                                                    >
                                                        Branch Manager
                                                    </option>
                                                    <option
                                                        value="branch-accountant"
                                                    >
                                                        Branch Accountant
                                                    </option>
                                                    <option
                                                        value="store-manager"
                                                    >
                                                        Store Manager
                                                    </option>
                                                    <option
                                                        value="b2b-sales-executive"
                                                    >
                                                        B2B Sales Executive
                                                    </option>
                                                    <option
                                                        value="b2c-sales-executive"
                                                    >
                                                        B2C Sales Executive
                                                    </option>
                                                    <option
                                                        value="brand-promoter"
                                                    >
                                                        Brand Promoter
                                                    </option>
                                                    <option
                                                        value="service-tech"
                                                    >
                                                        Service Executive
                                                    </option>
                                                    <option
                                                        value="service-manager"
                                                    >
                                                        Service Manager
                                                    </option>
                                                    <option
                                                        value="service-agent"
                                                    >
                                                        Service Assistant
                                                    </option>
                                                    <option
                                                        value="service-admin"
                                                    >
                                                        Service Administrator
                                                    </option>
                                                    <option
                                                        value="auditor-vendors"
                                                    >
                                                        Auditor (Vendors)
                                                    </option>
                                                    <option
                                                        value="purchase-admin"
                                                    >
                                                        Purchase Administrator
                                                    </option>
                                                    <option
                                                        value="purchase-manager"
                                                    >
                                                        Purchase Manager
                                                    </option>
                                                    <option value="mis-admin">
                                                        MIS Admin
                                                    </option>
                                                    <option
                                                        value="secondary-mis-admin"
                                                    >
                                                        Secondary MIS Admin
                                                    </option>
                                                    <option
                                                        value="installation-admin"
                                                    >
                                                        Installation
                                                        Administrator
                                                    </option>
                                                    <option
                                                        value="installation-manager"
                                                    >
                                                        Installation Manager
                                                    </option>
                                                    <option
                                                        value="ext-warr-admin"
                                                    >
                                                        Extended Warranty Admin
                                                    </option>
                                                    <option
                                                        value="replacement-manager"
                                                    >
                                                        Replacement Manager
                                                    </option>
                                                    <option value="doa-manager">
                                                        DOA Manager
                                                    </option>
                                                    <option
                                                        value="expense-admin"
                                                    >
                                                        Expense Admin
                                                    </option>
                                                    <option value="auditor">
                                                        Auditor
                                                    </option>
                                                    <option
                                                        value="online-sales-manager"
                                                    >
                                                        Online Sales Manager
                                                    </option>
                                                    <option
                                                        value="online-sales-associate"
                                                    >
                                                        Online Sales Associate
                                                    </option>
                                                    <option
                                                        value="marketing-admin"
                                                    >
                                                        Marketing Admin
                                                    </option>
                                                    <option
                                                        value="marketing-manager"
                                                    >
                                                        Marketing Manager
                                                    </option>
                                                    <option value="hr-admin">
                                                        HR Admin
                                                    </option>
                                                    <option value="cc-manager">
                                                        Help Desk Manager
                                                    </option>
                                                    <option value="cc-agent">
                                                        Help Desk Executive
                                                    </option>
                                                    <option
                                                        value="delivery-driver"
                                                    >
                                                        Delivery Driver
                                                    </option>
                                                    <option value="front-desk">
                                                        Front Desk
                                                    </option>
                                                    <option value="user">
                                                        Customer
                                                    </option>
                                                </select>
                                                <span
                                                    v-if="errors.user_type"
                                                    :class="['badge bg-danger']"
                                                    >Please enter valid matching
                                                    passwords.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.is_team_leader
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Is Team Leader?</span
                                                >
                                                <select
                                                    v-model="
                                                        form.is_team_leader
                                                    "
                                                    :value="form.is_team_leader"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                >
                                                    <option
                                                        value="0"
                                                        v-bind:value="false"
                                                    >
                                                        No
                                                    </option>
                                                    <option
                                                        value="1"
                                                        v-bind:value="true"
                                                    >
                                                        Yes
                                                    </option>
                                                    <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Division:</span
                                                >
                                                <v-select
                                                    v-model="form.division"
                                                    class="form-control"
                                                    type="text"
                                                    label="division_name"
                                                    :options="divisions"
                                                    :reduce="
                                                        (divisions) =>
                                                            divisions.division_name
                                                    "
                                                    name="division"
                                                    placeholder="Select Division Category"
                                                    :value="
                                                        (divisions) =>
                                                            divisions.division_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Item Category:</span
                                                >
                                                <v-select
                                                    v-model="form.category"
                                                    class="form-control"
                                                    type="text"
                                                    label="category_name"
                                                    :options="categories"
                                                    :reduce="
                                                        (categories) =>
                                                            categories.category_name
                                                    "
                                                    name="category"
                                                    placeholder="Select Item Category"
                                                    :value="
                                                        (categories) =>
                                                            categories.category_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Product:</span
                                                >
                                                <v-select
                                                    v-model="form.product"
                                                    class="form-control"
                                                    type="text"
                                                    label="product_name"
                                                    :options="products"
                                                    :reduce="
                                                        (products) =>
                                                            products.product_name
                                                    "
                                                    name="product"
                                                    placeholder="Select Product Category"
                                                    :value="
                                                        (products) =>
                                                            products.product_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Brands:</span
                                                >
                                                <v-select
                                                    v-model="form.brand"
                                                    class="form-control"
                                                    type="text"
                                                    label="brand_name"
                                                    :options="brands"
                                                    :reduce="
                                                        (brands) =>
                                                            brands.brand_name
                                                    "
                                                    name="brand"
                                                    placeholder="Select Brand"
                                                    :value="
                                                        (brands) =>
                                                            brands.brand_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br /><br />
                                <div class="col-md-12">
                                    <button
                                        style="width: 100% !important"
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal" tabindex="-1" role="dialog" id="viewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">User Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p><b>Employee ID: </b>{{ form.emp_id }}</p>
                            <p><b>Branch: </b>{{ form.branch }}</p>
                            <p><b>APX User: </b>{{ form.apx_user_id }}</p>
                            <p><b>First Name: </b>{{ form.first_name }}</p>
                            <p><b>Last Name: </b>{{ form.last_name }}</p>
                            <p><b>Phone: </b>{{ form.phone }}</p>
                            <p><b>E-mail: </b>{{ form.email }}</p>
                            <p><b>User Type: </b>{{ form.user_type }}</p>
                            <p><b>Employee Mapped To: </b>{{ emp.name }}</p>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="editModal">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edit User</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="editUser">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.emp_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Employee ID:</span
                                                >
                                                <v-select
                                                    v-model="form.emp_id"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="employees"
                                                    :reduce="
                                                        (employees) =>
                                                            employees.emp_code
                                                    "
                                                    name="employee"
                                                    placeholder="Select Employee Code"
                                                    :value="
                                                        (employees) =>
                                                            employees.emp_code
                                                    "
                                                ></v-select>

                                                <!--                            <select v-model="form.emp_id" style="width: 100% !important" class="form-control">-->
                                                <!--                                <option v-for="e in employees" :key="e.id" :value="e.emp_code">-->
                                                <!--                                    {{ e.emp_code}} - {{e.name}}-->
                                                <!--                                </option>-->
                                                <!--                                &lt;!&ndash;                                 <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> &ndash;&gt;-->
                                                <!--                            </select>-->
                                                <span
                                                    v-if="errors.emp_id"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    ID.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.branch
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Branch:</span
                                                >
                                                <v-select
                                                    v-model="form.branch"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="branches"
                                                    :reduce="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                    name="branch"
                                                    placeholder="Select Branch"
                                                    :value="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                ></v-select>
                                                <span
                                                    v-if="errors.branch"
                                                    :class="['badge bg-danger']"
                                                    >Please choose a valid
                                                    branch.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.apx_user_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >SAP User:</span
                                                >
                                                <!--                            <select v-model="form.apx_user_id" style="width: 100% !important" class="form-control">-->
                                                <!--                                <option v-for="e in employees" :key="e.id" :value="e.sp_code">-->
                                                <!--                                    {{ e.emp_code}} - {{ e.sp_code}} - {{e.name}}-->
                                                <!--                                </option>-->
                                                <!--                            </select>-->
                                                <v-select
                                                    v-model="form.apx_user_id"
                                                    class="form-control"
                                                    type="text"
                                                    label="fullname"
                                                    :options="employees"
                                                    :reduce="
                                                        (employees) =>
                                                            employees.sp_code
                                                    "
                                                    name="employee"
                                                    placeholder="Select Salesperson Code"
                                                    :value="
                                                        (employees) =>
                                                            employees.sp_code
                                                    "
                                                ></v-select>

                                                <span
                                                    v-if="errors.apx_user_id"
                                                    :class="['badge bg-danger']"
                                                    >Please choose a valid
                                                    user.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.apx_user_id
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >SPLR Code:</span
                                                >
                                                <select
                                                    v-model="form.slpr_code"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                >
                                                    <option
                                                        v-for="e in sp_details"
                                                        :key="e.id"
                                                        :value="e.SLPR_CODE"
                                                    >
                                                        {{ e.SLPR_CODE }} -
                                                        {{ e.SLPR_NAME }} -
                                                        {{ e.SLPR_PHONE }}
                                                    </option>
                                                </select>
                                                <!--                                <v-select v-model="form.apx_user_id" class="form-control" type="text" label="fullname" :options="employees" :reduce="employees => employees.sp_code" name="employee" placeholder="Select Salesperson Code" :value="employees => employees.sp_code"></v-select>-->

                                                <span
                                                    v-if="errors.apx_user_id"
                                                    :class="['badge bg-danger']"
                                                    >Please choose a valid
                                                    user.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.first_name
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >First Name:</span
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the first name of the employee"
                                                    v-model="form.first_name"
                                                />
                                                <span
                                                    v-if="errors.first_name"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    name.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.last_name
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Last Name:</span
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the last name of the employee"
                                                    v-model="form.last_name"
                                                />
                                                <span
                                                    v-if="errors.last_name"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    name.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.phone
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Phone:</span
                                                >
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Enter the phone number of the employee"
                                                    v-model="form.phone"
                                                    min="1000000000"
                                                />
                                                <span
                                                    v-if="errors.phone"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    number.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.email
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Email:</span
                                                >
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    placeholder="Enter the email of the employee"
                                                    v-model="form.email"
                                                />
                                                <span
                                                    v-if="errors.email"
                                                    :class="['badge bg-danger']"
                                                    >Please enter a valid
                                                    email.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div
                                                :class="[
                                                    'form-group',
                                                    errors.user_type
                                                        ? 'has-error'
                                                        : '',
                                                ]"
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >User Type:</span
                                                >
                                                <select
                                                    v-model="form.user_type"
                                                    class="form-control"
                                                >
                                                    <option value="sys-admin">
                                                        System Administrator
                                                    </option>
                                                    <option value="sales-admin">
                                                        Sales Admin
                                                    </option>
                                                    <option
                                                        value="zonal-manager"
                                                    >
                                                        Zonal Manager
                                                    </option>
                                                    <option
                                                        value="warehouse-manager"
                                                    >
                                                        Warehouse Manager
                                                    </option>
                                                    <option
                                                        value="branch-manager"
                                                    >
                                                        Branch Manager
                                                    </option>
                                                    <option
                                                        value="branch-accountant"
                                                    >
                                                        Branch Accountant
                                                    </option>
                                                    <option
                                                        value="store-manager"
                                                    >
                                                        Store Manager
                                                    </option>
                                                    <option
                                                        value="b2b-sales-executive"
                                                    >
                                                        B2B Sales Executive
                                                    </option>
                                                    <option
                                                        value="b2c-sales-executive"
                                                    >
                                                        B2C Sales Executive
                                                    </option>
                                                    <option
                                                        value="brand-promoter"
                                                    >
                                                        Brand Promoter
                                                    </option>
                                                    <option
                                                        value="service-tech"
                                                    >
                                                        Service Executive
                                                    </option>
                                                    <option
                                                        value="service-manager"
                                                    >
                                                        Service Manager
                                                    </option>
                                                    <option
                                                        value="service-agent"
                                                    >
                                                        Service Assistant
                                                    </option>
                                                    <option
                                                        value="service-admin"
                                                    >
                                                        Service Administrator
                                                    </option>
                                                    <option
                                                        value="purchase-admin"
                                                    >
                                                        Purchase Administrator
                                                    </option>
                                                    <option
                                                        value="purchase-manager"
                                                    >
                                                        Purchase Manager
                                                    </option>
                                                    <option value="mis-admin">
                                                        MIS Admin
                                                    </option>
                                                    <option
                                                        value="secondary-mis-admin"
                                                    >
                                                        Secondary MIS Admin
                                                    </option>
                                                    <option
                                                        value="installation-admin"
                                                    >
                                                        Installation
                                                        Administrator
                                                    </option>
                                                    <option
                                                        value="installation-manager"
                                                    >
                                                        Installation Manager
                                                    </option>
                                                    <option
                                                        value="ext-warr-admin"
                                                    >
                                                        Extended Warranty Admin
                                                    </option>
                                                    <option
                                                        value="replacement-manager"
                                                    >
                                                        Replacement Manager
                                                    </option>
                                                    <option value="doa-manager">
                                                        DOA Manager
                                                    </option>
                                                    <option
                                                        value="expense-admin"
                                                    >
                                                        Expense Admin
                                                    </option>
                                                    <option value="auditor">
                                                        Auditor
                                                    </option>
                                                    <option
                                                        value="auditor-vendors"
                                                    >
                                                        Auditor (Vendors)
                                                    </option>
                                                    <option
                                                        value="online-sales-manager"
                                                    >
                                                        Online Sales Manager
                                                    </option>
                                                    <option
                                                        value="online-sales-associate"
                                                    >
                                                        Online Sales Associate
                                                    </option>
                                                    <option
                                                        value="marketing-admin"
                                                    >
                                                        Marketing Admin
                                                    </option>
                                                    <option
                                                        value="marketing-manager"
                                                    >
                                                        Marketing Manager
                                                    </option>
                                                    <option value="hr-admin">
                                                        HR Admin
                                                    </option>
                                                    <option value="cc-manager">
                                                        Help Desk Manager
                                                    </option>
                                                    <option value="cc-agent">
                                                        Help Desk Executive
                                                    </option>
                                                    <option
                                                        value="delivery-driver"
                                                    >
                                                        Delivery Driver
                                                    </option>
                                                    <option value="front-desk">
                                                        Front Desk
                                                    </option>
                                                    <option value="user">
                                                        Customer
                                                    </option>
                                                </select>
                                                <span
                                                    v-if="errors.user_type"
                                                    :class="['badge bg-danger']"
                                                    >Please enter valid matching
                                                    passwords.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Is Team Leader?</span
                                                >
                                                <select
                                                    v-model="
                                                        form.is_team_leader
                                                    "
                                                    :value="form.is_team_leader"
                                                    style="
                                                        width: 100% !important;
                                                    "
                                                    class="form-control"
                                                >
                                                    <option
                                                        value="0"
                                                        v-bind:value="false"
                                                    >
                                                        No
                                                    </option>
                                                    <option
                                                        value="1"
                                                        v-bind:value="true"
                                                    >
                                                        Yes
                                                    </option>
                                                    <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Division:</span
                                                >
                                                <v-select
                                                    v-model="form.division"
                                                    class="form-control"
                                                    type="text"
                                                    label="division_name"
                                                    :options="divisions"
                                                    :reduce="
                                                        (divisions) =>
                                                            divisions.division_name
                                                    "
                                                    name="division"
                                                    placeholder="Select Division Category"
                                                    :value="
                                                        (divisions) =>
                                                            divisions.division_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Item Category:</span
                                                >
                                                <v-select
                                                    v-model="form.category"
                                                    class="form-control"
                                                    type="text"
                                                    label="category_name"
                                                    :options="categories"
                                                    :reduce="
                                                        (categories) =>
                                                            categories.category_name
                                                    "
                                                    name="category"
                                                    placeholder="Select Item Category"
                                                    :value="
                                                        (categories) =>
                                                            categories.category_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Product:</span
                                                >
                                                <v-select
                                                    v-model="form.product"
                                                    class="form-control"
                                                    type="text"
                                                    label="product_name"
                                                    :options="products"
                                                    :reduce="
                                                        (products) =>
                                                            products.product_name
                                                    "
                                                    name="product"
                                                    placeholder="Select Product Category"
                                                    :value="
                                                        (products) =>
                                                            products.product_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Brands:</span
                                                >
                                                <v-select
                                                    v-model="form.brand"
                                                    class="form-control"
                                                    type="text"
                                                    label="brand_name"
                                                    :options="brands"
                                                    :reduce="
                                                        (brands) =>
                                                            brands.brand_name
                                                    "
                                                    name="brand"
                                                    placeholder="Select Brand"
                                                    :value="
                                                        (brands) =>
                                                            brands.brand_name
                                                    "
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br /><br />
                                <div class="col-md-12">
                                    <button
                                        class="btn btn-danger"
                                        style="width: 100% !important"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="passwdModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Change Password</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="changePasswd">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password"
                                    />
                                    <span
                                        v-if="errors.password"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password_confirmation
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Confirm Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password_confirmation"
                                    />
                                    <span
                                        v-if="errors.password_confirmation"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <button
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin() && !$gate.isHRAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination },

    created() {
        this.getBranches();
        this.getUsers();
        this.getEmployees();
        this.getSalespersonDetails();
        this.getMasterItemCategories();
        this.getProductList();
        this.getBrandsList();
        this.getDivisions();
    },

    data() {
        let columns = [
            { width: "17%", label: "Name", name: "name" },
            { width: "10%", label: "Phone", name: "phone" },
            { width: "10%", label: "Employee ID", name: "emp_id" },
            { width: "8%", label: "Branch", name: "branch" },
            { width: "10%", label: "User Type", name: "user_type" },
            { width: "10%", label: "Active", name: "status" },
            { width: "35%", label: "View More", name: "ops" },
        ];
        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            form: new Form({
                id: "",
                emp_id: "",
                first_name: "",
                last_name: "",
                phone: "",
                email: "",
                branch: "",
                password: "",
                activation: "",
                apx_user_id: "",
                password_confirmation: "",
                user_type: "",
                slpr_code: "-1",
                is_team_leader: false,
                division: "",
                category: "",
                product: "",
                brand: "",
                designation: "",
                department: "",
            }),
            search_params: new Form({
                id: "",
                branch: "",
                results: "",
                name: "",
                phone: "",
                user_type: "",
                is_team_leader: "",
                division: "",
                category: "",
                product: "",
                brand: "",
                designation: "",
                department: "",
            }),
            branches: [],
            brands: [],
            divisions: [],
            products: [],
            categories: [],
            errors: [],
            employees: [],
            users: [],
            sp_details: [],
            params: new Form({
                name: null,
                phone: null,
                company: null,
                branch: null,
                zone: null,
                emp_code: null,
                erp_emp_code: null,
                sp_code: null,
                slpr_code: "-1",
                results: null,
                is_team_leader: null,
                division: null,
                category: null,
                product: null,
                brand: null,
                designation: null,
                department: null,
            }),
            emp: {},
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getMasterItemCategories() {
            axios.post("/api/getMasterItemCategories").then((response) => {
                this.categories = response.data;
            });
        },

        getDivisions() {
            axios.post("/api/getMasterDivisionList").then((response) => {
                this.divisions = response.data;
            });
        },

        getProductList() {
            axios.post("/api/getMasterProductList").then((response) => {
                this.products = response.data;
            });
        },

        getBrandsList() {
            axios.post("/api/getMasterBrandsList").then((response) => {
                this.brands = response.data;
            });
        },

        addModal() {
            this.form.reset();
            $("#addModal").modal("show");
        },

        addUser() {
            this.form
                .post("/api/addUser")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "User Added",
                            icon: "success",
                        });
                        this.getUsers();
                        this.errors = [];
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },

        getEmployees() {
            axios.post("/api/getAllEmployees").then((response) => {
                this.employees = response.data;
            });
        },

        getSalespersonDetails() {
            axios.post("/api/getEmployees").then((response) => {
                this.sp_details = response.data;
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getUsers(url = "/api/getUsers") {
            axios.post(url, { params: this.search_params }).then((response) => {
                this.users = response.data.data.data;
                this.configPagination(response.data.data);
            });
        },

        view(man) {
            this.form.fill(man);
            this.emp = man.employee;
            $("#viewModal").modal("show");
        },

        edit(man) {
            this.form.fill(man);
            this.getEmployees();
            $("#editModal").modal("show");
        },

        viewProfile(entry) {
            // this.$router.push('/user-profile/'+entry.user_id);
            // const routeData = this.$router.resolve({
            //     name: 'User Profile | O2Suite::Greydesk',
            //     query: {user_id:entry.id, lead_profile_id:entry.lead_id, phone:entry.phone}
            // });
            // window.open(routeData.href, '_blank');
            window.open(
                "/user-profile/" +
                    entry.id +
                    "/" +
                    entry.lead_id +
                    "/" +
                    entry.phone,
                "_blank"
            );
            entry: null;
        },

        reset() {
            this.search_params.reset();
            this.getUsers();
        },

        editUser() {
            this.form
                .post("/api/editUser")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "User Updated",
                            icon: "success",
                        });
                        this.getUsers(
                            "/api/getUsers" +
                                "?page=" +
                                this.pagination.currentPage
                        );
                        this.errors = [];
                        $("#editModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },

        passwd(man) {
            this.form.fill(man);
            $("#passwdModal").modal("show");
        },

        changePasswd() {
            this.form
                .post("/api/changePasswd")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "Password Updated",
                            icon: "success",
                        });
                        this.getUsers();
                        this.errors = [];
                        $("#passwdModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },

        changeUserStatus(id) {
            axios
                .post("/api/changeUserStatus", { id: id })
                .then(() => {
                    this.getUsers(
                        "/api/getUsers" + "?page=" + this.pagination.currentPage
                    );
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        exportUsers(url = "/api/usersExport") {
            axios({
                url: "/api/usersExport",
                data: {
                    results: this.results,
                    params: this.search_params,
                },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "users.xlsx");
            });
        },
    },
};
</script>
